/**
 * Created by majianb on 2019/4/10.
 * 数量金额单价格式化算法
 */
import {PosInitData} from 'tplus-poslogin';

/**
 * 公共格式化
 */
export class Format{
    constructor ()
    {
        // 单价小数位数
        this.priceDecimalDigits=PosInitData("PricePrecision");
        // 数量小数位数
        this.quantityDecimalDigits=PosInitData("QuantityPrecision");
        this.amountDecimalDigits=2;
    }
    isNumber(obj) {
      if (NaN != Number(obj)) {
        return true;
      }
      else{
        return false;
      }
    }
    /**
   * 格式化数量
   * @param {*数量} value 
   */
  FormatQuantity(value)
  {
    if(this.isNumber(value))
    {
      return value.Round(this.quantityDecimalDigits);
    }
    return value
  }
  /**
   * 格式化单价
   * @param {*单价} value 
   */
  FormatPrice(value)
  {
    if(this.isNumber(value))
    {
      return value.Round(this.priceDecimalDigits);
    }
    return value
  }

  /**
   * 格式化金额
   * @param {*金额} value 
   */
  FormatAmount(value)
  {
    if(this.isNumber(value))
    {
      return value.Round(this.amountDecimalDigits);
    }
    return value
  }

  
  Format(value,precision)
  {
    if(this.isNumber(value))
    {
      return value.Round(precision);
    }
    return value
  }
}